<template>
  <div class="checkout-item-image">
    <img :src="src" :alt="alt" />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.checkout-item-image {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 2rem 2rem 1rem;
}

.checkout-item-image img {
  max-width: 150px;
}
</style>
